export default __webpack_public_path__ + "static/media/pair-programming-table.672de79b.jpg";